var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('question',{attrs:{"text":_vm.$t(_vm.item.text, _vm.privacyPolicyLink)}}),_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"10","md":"8"}},[_c('div',{staticClass:"num-input-item__text-input"},[_c('text-input',{attrs:{"validator":_vm.validate,"error-text":_vm.errorText},on:{"change":_vm.handleChange}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }